import React from "react";
import PropTypes from "prop-types";
import LocalNavSoftLink from "../LocalNavSoftLink";

// Focused component for the primary company-specific top shortcuts.
export default function DashboardLinks({ pathname, hasCompanySelected }) {
    if (!hasCompanySelected) return null;

    const isFlowsActive = () => pathname.includes("/flows/");

    return (
        <>
            <LocalNavSoftLink
                id="my-dashboard"
                destination="/dashboard"
                text="My Dashboard"
                isCollapsed
                collapsedIcon="/Images/Icons/home.png"
            />
            <LocalNavSoftLink
                id="flows"
                destination="/flows/design"
                text="Flows"
                feature="flow"
                isActive={isFlowsActive}
                isCollapsed
                collapsedIcon="/Images/Icons/primary-flow.png"
            />
            <LocalNavSoftLink
                id="make-a-wish"
                destination="/make-a-wish"
                text="Make-A-Wish"
                feature="make-a-wish"
                isCollapsed
                collapsedIcon="/Images/Icons/make-a-wish.png"
            />
        </>
    );
}

DashboardLinks.propTypes = {
    pathname: PropTypes.string.isRequired,
    hasCompanySelected: PropTypes.bool.isRequired,
};
